import { Input } from '@repo/ui/components/form/input';
import { Button } from '@repo/ui/components/button';
import { useForm } from '@repo/ui/hooks/use-form';
import { CreateProductCategory } from '@repo/shared-types';
import { useAsync } from '@repo/ui/hooks/use-async';
import { productApi } from '@repo/api-client';
import { useCurrentClub } from '@/hooks/use-current-club';
import { useRevalidator } from 'react-router';

export function CreateCategoryForm({ onClose }: { onClose: () => void }) {
  const revalidator = useRevalidator();
  const club = useCurrentClub();
  const { execute: onSubmit } = useAsync(async () => {
    await productApi.createCategory(club.id, values);
    revalidator.revalidate();
    onClose();
  });
  const { ref, values, errors } = useForm<CreateProductCategory>({
    initialValues: {
      name: '',
      description: '',
    },
    onSubmit,
  });
  return (
    <form ref={ref} className="w-full flex flex-col gap-4">
      <Input label="Nombre" type="text" name="name" required errors={errors} />
      <Input label="Descripción" type="text" name="description" required errors={errors} />
      <Button type="submit">Crear</Button>
    </form>
  );
}
